// Logged-in app page: hook packs. Keep keys in sync with pl/appHooks.ts.
// Paczka 34 (MINIMAL-2026-09-18): the same rewrites as the Polish file — one sentence
// per state, no "(n)" in delete titles. P2-D (21.09): the `generator` block went away
// with the hook generator; its `unknown-placeholder` rule lives on as `coll.unknownPlaceholder`.
export const appHooks = {
  head: {
    title: 'Hooks',
  },
  intro: {
    title: 'Text on your video that grabs attention',
  },
  // THE "VARIABLES" DIALOG (rule 33, round B-R3). Only the variables the parser
  // substitutes today (`lib/textTemplates.ts`). The example is the RESULT of the
  // substitution, not the variable spelled again: the row shows what a viewer
  // will read. The "Random" group waits for `{random_emoji}` — a heading with no
  // rows does not render.
  variables: {
    label: 'Variables',
    intro: 'You fill in the values when you plan the pack for publishing.',
    fixed: 'Fixed',
    random: 'Random',
    artist: 'artist name',
    artistExample: 'Nocna Zmiana did it again',
    title: 'track title',
    titleExample: 'Mokry asfalt on headphones',
    timestamp: 'moment in the track',
    timestampExample: 'the moment at 0:31 is enormous',
    // Screen-reader names; the component substitutes {variable}.
    insert: 'Insert {variable}',
    copy: 'Copy {variable}',
    copied: 'Copied',
    copyFailed: 'Could not copy.',
    close: 'Close',
  },
  list: {
    heading: 'Packs',
    collection_one: 'pack',
    collection_few: 'packs',
    collection_many: 'packs',
    hooks_one: 'hook',
    hooks_few: 'hooks',
    hooks_many: 'hooks',
    newCollection: 'New pack',
  },
  form: {
    name: 'Name',
    namePlaceholder: 'e.g. Starter hooks',
    desc: 'Description',
    descPlaceholder: 'Optional',
    create: 'Create',
    cancel: 'Cancel',
  },
  state: {
    loadError: 'Could not load the packs.',
    emptyTitle: 'No packs of your own yet',
    emptyBody: 'Hooks are short captions at the top of an edit. Create a pack and EDIMI picks one from it at the start of every series.',
    emptyBodyWithSystem: '{n} ready ones from EDIMI are above and you can use them right away. Create your own when you want to cut it your way.',
    emptyBodyWithSystem_one: 'One ready one from EDIMI is above and you can use it right away. Create your own when you want to cut it your way.',
    emptyBodyWithSystem_few: '{n} ready ones from EDIMI are above and you can use them right away. Create your own when you want to cut it your way.',
    emptyBodyWithSystem_many: '{n} ready ones from EDIMI are above and you can use them right away. Create your own when you want to cut it your way.',
  },
  coll: {
    own: 'yours',
    // The one lint rule the client knows itself (`hookValidation`); moved out of the
    // generator block, which went away with the generator (P2-D).
    unknownPlaceholder: 'unknown placeholder - nothing to substitute',
    more: 'More actions: {name}',
    expand: 'Expand pack {name}',
    collapse: 'Collapse pack {name}',
    deleteCollectionTitle: 'Delete pack',
    deleteAsk: 'Delete this pack?',
    deleteRow: 'Hooks',
    emptyItems: 'No hooks',
    deleteItemTitle: 'Delete hook',
    deleteItemLabel: 'Delete hook “{text}”',
    deleteItemAsk: 'Delete the hook “{text}”?',
    addHeading: 'Add hooks',
    add: 'Add',
    pasteCount: '{count} hooks to add',
    pasteCount_one: '{count} hook to add',
    pasteCount_few: '{count} hooks to add',
    pasteCount_many: '{count} hooks to add',
    addN: 'Add {count} hooks',
    addN_one: 'Add {count} hook',
    addN_few: 'Add {count} hooks',
    addN_many: 'Add {count} hooks',
  },
  system: {
    readOnly: 'read-only',
    count: '{n} · ready to use',
    copyToMine: 'Copy to mine',
    copyDone: 'Copied to my packs.',
    heading: 'EDIMI packs',
    andMore: '…and {count} more',
  },
  library: {
    mine: 'Mine',
    all: 'All packs',
    edimi: 'EDIMI',
    newPack: 'New pack',
    save: 'Save',
    rename: 'Rename',
    openPack: 'Open {name}',
    selectPack: 'Select the “{name}” pack',
    deletePack: 'Delete pack',
    deletePacksAsk: 'Delete {count} packs?',
    deletePacksAsk_one: 'Delete this pack?',
    deletePacksAsk_few: 'Delete {count} packs?',
    deletePacksAsk_many: 'Delete {count} packs?',
    deletePacksDo: 'Delete {count} packs',
    deletePacksDo_one: 'Delete pack',
    deletePacksDo_few: 'Delete {count} packs',
    deletePacksDo_many: 'Delete {count} packs',
    selected: 'selected',
    // Czasownik, nie samo słowo zbioru: obok stoi pigułka zakresu „Wszystkie”,
    // a te dwa przyciski robią rzeczy przeciwne (przegląd D).
    selectAll: 'Select all',
    selectNone: 'None',
    emptyAll: 'No hook packs',
    emptyAllBody: 'Create your own pack or open EDIMI to get started.',
    emptyEdimi: 'No EDIMI packs',
    emptyEdimiBody: 'EDIMI packs will appear here when they are available in this language.',
    choosePackPrompt: 'Choose a pack',
    choosePackPromptBody: 'Hooks from the selected pack will appear here.',
    actionFailed: 'Could not complete the action.',
    back: 'Hooks',
    selectItem: 'Select hook “{text}”',
    moveItems: 'Move to another pack',
    copyItems: 'Copy to another pack',
    deleteItemsAsk: 'Delete {count} hooks?',
    deleteItemsAsk_one: 'Delete this hook?',
    deleteItemsAsk_few: 'Delete {count} hooks?',
    deleteItemsAsk_many: 'Delete {count} hooks?',
    deleteItemsDo: 'Delete {count} hooks',
    deleteItemsDo_one: 'Delete hook',
    deleteItemsDo_few: 'Delete {count} hooks',
    deleteItemsDo_many: 'Delete {count} hooks',
    addRules: 'One hook per line · keep it short and about the music · use {artist} and {timestamp} as variables',
    targetPack: 'Target pack',
    choosePack: 'Choose a pack',
    confirmMove: 'Move {count} hooks',
    confirmMove_one: 'Move {count} hook',
    confirmMove_few: 'Move {count} hooks',
    confirmMove_many: 'Move {count} hooks',
    confirmCopy: 'Copy {count} hooks',
    confirmCopy_one: 'Copy {count} hook',
    confirmCopy_few: 'Copy {count} hooks',
    confirmCopy_many: 'Copy {count} hooks',
    noTarget: 'You have no other pack of your own.',
    noTargetBody: 'Create an empty hook pack first.',
    errorConflict: 'The target pack has different content in the same place.',
    errorChanged: 'The pack changed during the action.',
    errorMissing: 'A hook or the pack no longer exists.',
    errorSame: 'Choose a different target pack.',
    errorGeneric: 'Could not complete the action.',
    invalid: 'Fix the text before adding it',
    retry: 'Try again',
    newPackFailed: 'Could not create the pack.',
    // Paczka 34: the shelf's quiet actions, the selection bar and one sentence of finality.
    select: 'Select',
    selectedCount: 'Selected: {count}',
    deleteCount: 'Delete ({count})',
    moveShort: 'Move',
    copyShort: 'Copy',
    loadFailed: 'Could not load your hook packs.',
    invalidLine: 'line {line} {reason}',
    toastAdded: 'Added {count} hooks.',
    toastAdded_one: 'Added {count} hook.',
    toastAdded_few: 'Added {count} hooks.',
    toastAdded_many: 'Added {count} hooks.',
    toastMoved: 'Moved {count} hooks to “{name}”.',
    toastMoved_one: 'Moved {count} hook to “{name}”.',
    toastMoved_few: 'Moved {count} hooks to “{name}”.',
    toastMoved_many: 'Moved {count} hooks to “{name}”.',
    toastCopied: 'Copied {count} hooks to “{name}”.',
    toastCopied_one: 'Copied {count} hook to “{name}”.',
    toastCopied_few: 'Copied {count} hooks to “{name}”.',
    toastCopied_many: 'Copied {count} hooks to “{name}”.',
    toastPackDeleted: 'Pack deleted.',
    toastPackDeleteFailed: 'Could not delete the pack.',
  },
  field: {
    label: 'New hooks',
    placeholder: 'one hook per line',
    lines_one: '{count} line',
    lines_few: '{count} lines',
    lines_many: '{count} lines',
  },
}
